import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingUpdate = new Subject<any>();
  loadingUpdate$ = this.loadingUpdate.asObservable();

  constructor() { }

  
  /**
   * 
   * @param status new loading status 'true' or 'false'
   */
  changeSpinnerStatus(status : string, component: string){
    this.loadingUpdate.next(status)
  }

}
